import React, { useState, useEffect } from "react";
import _ from "lodash";
import { _makeId } from "../utils/helper";
import { FieldWrapper } from ".";

const InputCheckboxRadio = (props) => {
  const randomId = _makeId(10);
  const [fieldValue, setFieldValue] = useState(props.value);
  const [disableOptions, setDisableOptions] = useState([]);

  useEffect(() => {
    setFieldValue(props.value);
  }, [props.value]);

  useEffect(() => {
    props.disableOptions !== undefined
      ? setDisableOptions(props.disableOptions)
      : setDisableOptions([]);
    // eslint-disable-next-line
  }, [props.disableOptions]);

  const _onChange = (v) => {
    if (props.type === "radio") {
      let temp = v;

      if (v === "true") {
        temp = true;
      }
      if (v === "false") {
        temp = false;
      }

      setFieldValue(temp);
      props.onChange(temp);
    } else {
      // Checkbox
      const idx = fieldValue.indexOf(v);
      let temp = [...fieldValue];

      if (idx > -1) {
        temp.splice(idx, 1);
      } else {
        temp.push(v);
      }
      setFieldValue(temp);
      props.onChange(temp);
    }
  };

  const _isChecked = (v) => {
    if (props.type === "radio") {
      if (v.toString() === fieldValue.toString()) {
        return true;
      }
    } else {
      // Checkbox
      if (fieldValue.indexOf(v) > -1) {
        return true;
      } else {
        return false;
      }
    }

    return false;
  };

  const fieldHasError = _.isString(props.error) && props.error;

  return (
    <FieldWrapper
      label={props.label}
      error={fieldHasError}
      twoColumnLayout={props?.twoColumnLayout}
    >
      <div class={`tema-form ${props.listClass || ""}`}>
        {props.options.map((option, index) => (
          <div key={index} className={`flex justify-start ${props.itemClass || ""}`}>
            <input
              type={props.type}
              name={props.name}
              value={JSON.stringify(option.value)}
              id={randomId + index}
              onChange={(e) => {
                _onChange(JSON.parse(e.target.value));
              }}
              checked={_isChecked(option.value)}
              disabled={disableOptions.indexOf(option.value) >= 0}
            />
            <label htmlFor={randomId + index}></label>
            <label htmlFor={randomId + index}>{option.label}</label>
          </div>
        ))}
      </div>
    </FieldWrapper>
  );
};

export default InputCheckboxRadio;
